export default __webpack_public_path__ + "static/media/apple-store.58fa511d.svg";